import { v4 as uuidv4 } from 'uuid';
import { Entity } from "app/models/entity";
import { Column } from "app/partials/entity/Table";

const generateKeyFromArray = <T extends Entity,>(entities: Array<T | Column<T>>): string => {
    return `${uuidv4()}~${entities.map((entity: T | Column<T>) => ((entity as Entity)?.id ?? (entity as Column<T>).key ) ).join('-')}`;
}

export const generateKey = <T extends Entity,>(entity?: T | Column<T> | Array<T | Column<T>>): string => {
    if(!entity) {
        return uuidv4();
    }
    if(Array.isArray(entity)) {
        return generateKeyFromArray(entity);
    }
    return `${uuidv4()}~${((entity as Entity)?.id ?? (entity as Column<T>).key)}`;
}

export const traverseKeyObj = (obj:any, path:string): any =>{
    return path?.split('.').reduce(
        (obj, key) => (obj && obj[key] !== 'undefined') ?
            obj[key] : undefined,
        obj);
}

export const traverseArrayKeyObj = (obj:any, path:string): any =>{
    const position = path?.split('[')[1]?.split(']')[0];
    const key = path?.split('[')[0];
    const post = path?.split(']')[1];
    const endObj = obj?.[key]?.[position]
    return post ? traverseKeyObj(endObj, post) : endObj;
}

export const traverseKey = (obj:any, path:string): any =>
{
    let normalizedPath = "";
    for(let i=0; i<path.length; i++){
        const char = path[i];
        if(char === '['){
            normalizedPath += '.';
        }
        else if(char === ']'){
            continue;
        }
    }
}

export const deepWriteKeyObj = (obj:any, path:string, value:any): any => {
    const keys = path.split('.');
    const lastKey = keys?.pop();
    const lastObj = keys?.reduce((obj, key) =>
        obj[key] = obj[key] || {}, obj);
    if(lastObj && lastKey){
        lastObj[lastKey] = value;
    }
    return obj;
}





